import { t } from 'i18next';

export const geStatusConfig = () => ({
  added: {
    text: t('ui.snackbar.compareAddedText'),
    buttonText: t('ui.snackbar.moveTo'),
    mode: 'added',
    redirectTo: '/compare/',
  },
  removed: {
    text: t('ui.snackbar.compareRemovedText'),
    buttonText: t('ui.snackbar.dismiss'),
    mode: 'removed',
  },
  error: {
    text: t('ui.snackbar.compareErrorText'),
    buttonText: t('ui.snackbar.tryAgain'),
    mode: 'error',
  },
  productListCountAlert: {
    header: t('ui.snackbar.compareProductListAlertHeader'),
    text: t('ui.snackbar.compareAlertText'),
    buttonText: t('ui.snackbar.moveToList'),
    mode: 'alert',
    redirectTo: '/compare/',
  },
  listCountAlert: {
    header: t('ui.snackbar.compareListsAlertHeader'),
    text: t('ui.snackbar.compareAlertText'),
    buttonText: t('ui.snackbar.moveToList'),
    mode: 'alert',
    redirectTo: '/compare/',
  },
});
